import { Button, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
type EmptyHomeworkManageTableProps = {
    onOpen: () => void;
};
export default function EmptyHomeworkManageTable(props: EmptyHomeworkManageTableProps) {
    const { t } = useTranslation();
    return (
        <CardContent
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                width: '100%',
                height: '100%',
                borderRadius: '4px 0 0 0',
                opacity: 1,
            }}
        >
            <Typography variant='h5'>{t('homework.empty.title')}</Typography>
            <Typography variant='body1'>{t('homework.empty.description')}</Typography>
            <Button onClick={props.onOpen} variant='contained' color='primary' startIcon={<AddIcon />}>
                {t('homework.publish.title')}
            </Button>{' '}
        </CardContent>
    );
}
